/* ================================
   CAROUSEL SLIDER
================================ */

if (!customElements.get("carousel-slider")) {
  customElements.define(
    "carousel-slider",
    class CarouselSlider extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('[class*="grid-carousel"]');
        if (!this.carousel) return;
        this.initialize();
      }

      initialize() {
        const autoplayEnabled = this.getAttribute("data-autoplay") === "true";
        const autoPlaySpeed =
          parseInt(this.getAttribute("data-speed"), 10) * 1000;

        this.carousel.style.display = "block";

        this.flickity = new Flickity(this.carousel, {
          autoPlay: autoplayEnabled ? autoPlaySpeed : false,
          cellAlign: "left",
          groupCells: true,
          contain: true,
          resize: true,
          draggable: true,
          prevNextButtons: false,
          fade: false,
          cellSelector: ".grid-item",
          initialIndex: 0,
          pageDots: true,
          wrapAround: false,
          accessibility: false,
          watchCSS: true,
        });

        this.flickity.on("change", (index) => {
          document.dispatchEvent(
            new CustomEvent("slider:slide-change", {
              detail: {
                id: this.getAttribute("id"),
                index,
              },
            }),
          );
        });
      }
    },
  );
}

/* ================================
   CAROUSEL NAVIGATION (FIXED)
================================ */

if (!customElements.get("carousel-navigation")) {
  customElements.define(
    "carousel-navigation",
    class CarouselNavigation extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init(retry = 1, maxRetry = 5) {
        if (retry > maxRetry) return;

        const id = this.getAttribute("for");
        this.carouselComponent = document.querySelector(`#${id}`);
        this.wrap = this.dataset.wrap === "true";

        if (!this.carouselComponent || !this.carouselComponent.flickity) {
          setTimeout(() => this.init(retry + 1), 300);
          return;
        }

        this.flickity = this.carouselComponent.flickity;
        this.buttonPrev = this.querySelector(".js-prev");
        this.buttonNext = this.querySelector(".js-next");

        if (!this.buttonPrev || !this.buttonNext) return;

        this.buttonPrev.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.buttonPrev.getAttribute("aria-disabled") === "true") return;
          this.flickity.previous();
        });

        this.buttonNext.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.buttonNext.getAttribute("aria-disabled") === "true") return;
          this.flickity.next();
        });

        const updateButtons = () => {
          if (this.wrap) return;

          const totalSlides = this.flickity.slides.length;
          const index = this.flickity.selectedIndex;

          const isFirst = index === 0;
          const isLast = index === totalSlides - 1;

          isFirst
            ? this.disableButton(this.buttonPrev)
            : this.enableButton(this.buttonPrev);

          isLast
            ? this.disableButton(this.buttonNext)
            : this.enableButton(this.buttonNext);
        };

        this.flickity.on("select", updateButtons);
        this.flickity.on("resize", updateButtons);

        // 🔑 force initial state
        updateButtons();
      }

      enableButton(button) {
        button.classList.remove("pill-nav-item-disabled", "focus-none");
        button.setAttribute("aria-disabled", "false");
        button.setAttribute("tabindex", "0");
      }

      disableButton(button) {
        button.classList.add("pill-nav-item-disabled", "focus-none");
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("tabindex", "-1");
      }
    },
  );
}
